<template>
  <div class="meet-us">,
    <GmapMap
      :center="activeCenter"
      :zoom="zoom"
      :options="activeOptions"
      map-type-id="roadmap"
      class="g-map"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
      />
    </GmapMap>
    <div class="content-wrap">
      <div class="content column items-center">
      <div class="section">
        <p class="header">Meet us</p>
        <p class="desc gt-xs">
          We develop software for fintech companies used by thousands of users all around.
        </p>
      </div>
      <div class="section column items-center">
        <img class="icon icon--pin" src="@/assets/icon_pin.png"/>
        <p class="bold">3 Ashley Road</p>
        <p>Bournemouth, England, BH1 4LE</p>
      </div>
      <div class="section column items-center">
        <img class="icon icon--email" src="@/assets/icon_email.png"/>
        <a class="line-link" href="mailto:contact@feat.software">contact@feat.software</a>
      </div>
      <div class="section social-icons">
        <a href="https://www.facebook.com/featSoftware/" target="_blank">
          <img class="icon icon--fb" src="@/assets/logo_fb--green.png" alt="facebook"/>
        </a>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MeetUs',
  data() {
    return {
      center: {
        xs: { lat: 50.727612, lng: -1.837147 },
        sm: { lat: 50.727612, lng: -1.820147 },
      },
      zoom: 15,
      markers: [{
        position: { lat: 50.727612, lng: -1.837147 },
      }],
      options: {
        xs: {
          zoomControl: true,
          mapTypeControl: true,
          streetViewControl: true,
          zoomControlOptions: {
            position: 3,
          },
          streetViewControlOptions: {
            position: 1,
          },
          mapTypeControlOptions: {
            position: 1,
          },
        },
        sm: {
          zoomControl: true,
          mapTypeControl: true,
          streetViewControl: true,
          zoomControlOptions: {
            position: 6,
          },
          streetViewControlOptions: {
            position: 6,
          },
          mapTypeControlOptions: {
            position: 9,
          },
        },
      },
    };
  },
  computed: {
    ...mapState('viewport', ['viewport']),
    activeOptions() {
      const { options, viewport } = this;
      return options[viewport.name] || options.sm;
    },
    activeCenter() {
      const { center, viewport } = this;
      return center[viewport.name] || center.sm;
    },
  },
};
</script>

<style scoped lang="stylus">
  @import '../../styles/variables';

  .bold{
    font-weight: 600;
  }

  .meet-us{
    position: relative;
    .g-map{
      position: relative;
      z-index: 610;

      &:before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 200px;
        background-image: linear-gradient(0deg, rgba(255,255,255,0.00) 0%, #FFFFFF 75%);
        z-index: 800;
        transition: height 0.3s;
      }
      &:hover{
        &:before{
          height: 30px;
        }
      }
    }


    .content{
      /*max-width: 240px;*/
      max-width: 80%;
      margin: 0 auto;
      position: relative;
      top: -80px;
      background: white;
      font-size: 16px;
      line-height: 33px;
      z-index: 801;
    }

    .header{
      font-family: 'Dosis', sans-serif;
      font-weight: 600;
      font-size: 24px;
      padding-top: 40px;
    }

    .icon{
      margin-bottom: 20px;
    }

    .section{
      &:not(:last-child){
        margin-bottom: 40px;
      }
    }

    .social-icons{
      .icon {
        &:not(:last-child){
          margin-right: 20px;
        }
      }
    }
    a{
      font-weight: 300;
    }
  }

  .g-map{
    width: 100%;
    margin: 0 auto;
    height: 345px;
  }

  @media(min-width: $breakpoint-sm-min) {
    .meet-us{
      position: relative;
      top: -150px;
      margin-bottom: -150px;

      .g-map {
        &:before {
          height: 535px;
          background-image: linear-gradient(0deg, rgba(252, 252, 252, 0.00) 0%, #F7F7F7 75%);
        }
        &:hover{
          &:before{
            height: 200px;
          }
        }
      }

      .content{
        width: 450px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: auto;
        bottom: 160px;
        padding: 0 80px 53px;
        align-items: flex-start;
        .section{
          align-items: flex-start;
        }
      }
      .header{
        font-size: 40px;
        line-height: normal;
        padding-top: 75px;
        margin-bottom: 30px;
      }
    }
    .g-map{
      height: 1300px;
    }
  }

  @media(min-width: $breakpoint-md-min) {
    .meet-us{
      top: -170px;
      margin-bottom: -170px;

      &:before{
        height: 535px;
      }

      .icon{
        margin-bottom: 10px;
      }

      .content-wrap{
        padding: 0;
        margin: 0 auto;
        width: 1120px;
        position: relative;
      }

      .content{
        right: 0;
        left: auto;
        transform: translateX(0);
        padding-bottom: 40px;
        padding-left: 80px;
        padding-right: 80px;
        bottom: 145px;

        p, a{
          font-size: 16px;
          line-height: 26px;
        }
        .header{
          font-size: 30px;
          padding-top: 60px;
          margin-bottom: 20px;
        }
      }

      .section:not(:last-child){
        margin-bottom: 30px;
      }

      .section:nth-child(2){
        margin-bottom: 20px;
      }
    }
    .g-map{
      height: 985px;
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .meet-us{
      top: -240px;
      margin-bottom: -240px;

      &:before{
        height: 880px;
      }

      .content-wrap{
        width: 1520px;
      }

      .content{
        bottom: 160px;
        width: 560px;

        .header{
          font-size: 40px;
          line-height: normal;
          padding-top: 90px;
        }

        .section{
          &:not(:last-child){
            margin-bottom: 35px;
          }
        }

        p,a{
          font-size: 18px;
          line-height: 33px;
        }
      }
      .g-map{
        height: 1298px;
        &:hover{
          &:before{
            height: 280px;
          }
        }
      }
    }

  }
</style>
